<div class="main-preloader" [@loadingAnimation]>
	<p>{{ strLoggingOut | lowercase }}</p>
	<img class="preloader" src="/assets/images/preloaders/progress.gif" />
</div>
